/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./modelInfo.vue?vue&type=template&id=efe32318&"
import script from "./modelInfo.vue?vue&type=script&lang=js&"
export * from "./modelInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports